import React, { useMemo } from 'react';
import { Typography, Tooltip, Tag } from 'antd';
import { regionColors } from './GridItem';

const { Title, Text } = Typography;

export interface SequenceViewProps {
  positions: Array<{ position: string; aa: string; region: string }>;
  regions: Record<string, string>;
  lightMode?: boolean;
  title?: string;
}

// 共享的序列视图组件：
// - 非轻量模式：显示着色的氨基酸序列
// - 轻量模式：按区域块显示序列，使用 Tag + 着色文本，性能更好
const SequenceView: React.FC<SequenceViewProps> = ({ 
  positions, 
  regions, 
  lightMode = false, 
  title = '序列视图'
}) => {

  if (lightMode) {
    // 轻量模式：按区域输出块
    return (
      <div>
        <Title level={5}>{title}</Title>
        <div style={{
          fontFamily: 'monospace',
          lineHeight: '2',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          padding: '12px',
          backgroundColor: '#f9f9f9',
          borderRadius: '4px',
          border: '1px solid #eee',
          overflow: 'auto'
        }}>
          {Object.entries(regions || {}).map(([region, seq]) => (
            <div key={region} style={{ marginBottom: 8 }}>
              <Tag color={regionColors[region] || 'default'} style={{ marginRight: 8 }}>
                {region}
              </Tag>
              <Text style={{
                color: regionColors[region] || '#000',
                fontWeight: region.startsWith('CDR') ? 'bold' : 'normal'
              }}>
                {seq}
              </Text>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // 非轻量模式：着色序列
  return (
    <div>
      <Title level={5}>{title}</Title>
      <div style={{
        fontFamily: 'monospace',
        fontSize: '1.1em',
        lineHeight: '1.5',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        padding: '12px',
        backgroundColor: '#f9f9f9',
        borderRadius: '4px',
        border: '1px solid #eee',
        overflow: 'auto'
      }}>
          {positions.map((pos, idx) => {
            const isCDR = pos.region?.startsWith('CDR');
            const color = regionColors[pos.region] || '#000';
            return (
              <Tooltip key={idx} title={`${pos.position} (${pos.region})`}>
                <Text style={{ color, fontWeight: isCDR ? 'bold' : 'normal' }}>
                  {pos.aa}
                </Text>
              </Tooltip>
            );
          })}
        </div>
      </div>
  );
};

export default SequenceView;
